var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.25C4.75736 4.25 3.75 5.25736 3.75 6.5V14.5C3.75 15.7426 4.75736 16.75 6 16.75H6.5C7.19035 16.75 7.75 17.3096 7.75 18V20.8046L11.9955 16.945C12.1658 16.7902 12.3881 16.7284 12.5997 16.7566C12.6325 16.7523 12.666 16.75 12.7 16.75H17.9998C19.2425 16.75 20.25 15.7426 20.25 14.5V6.5C20.25 5.25736 19.2426 4.25 18 4.25H6ZM12.7899 18.25H17.9998C20.0709 18.25 21.75 16.5711 21.75 14.5V6.5C21.75 4.42893 20.0711 2.75 18 2.75H6C3.92893 2.75 2.25 4.42893 2.25 6.5V14.5C2.25 16.5711 3.92893 18.25 6 18.25H6.25V21.3697C6.25 22.4549 7.53788 23.0246 8.34084 22.2946L12.7899 18.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.3aa5b25f49746b8e444d566851a4d6b5.svg";
export { ForwardRef as ReactComponent };